<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="configAuto" :onConfigReady="onConfigReady" :queryHandler="queryHandler" :eventHandler="queryEventHanlder" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>

        <!--<el-tabs name="tabs" class="mt10" v-model="activeName" @tab-click="handleClick">-->
            <!--<el-tab-pane label="自建" name="virtual"></el-tab-pane>-->
            <!--<el-tab-pane label="平台" name="platform"></el-tab-pane>-->
        <!--</el-tabs>-->

        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="configAuto" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="domHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { openRegionForSelectDlg } from '../comn/regionSelectDlg'
    //
    import retailerApi from '../../api/retailer'
    import comnApi from '../../api/comn'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    export default {
        name: 'swb-retailer-com-list-of-mine-for-select',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '我的零售客户机构管理-选择列表',
        props: {
            checkBox: {
                type: Boolean,
                default: false
            },
            needDisabled: {
                type: Boolean,
                default: false
            },
            selectIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                confKey: 'swb-retailer-com-list-of-mine',
                configAuto: true,
                domHeight: 500,
                //
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 240,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowNoShow: true, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                activeName: 'virtual',
                activeNameCache: 'virtual',
                //
                provinceId: null,
                cityId: null,
                countyId: null
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.multiSelect = this.checkBox;
            this.multiPageSelect = this.checkBox;
            //
            this.toGetRetailerComList();
        },
        mounted() {
            //
            this.initResultTable();
            //回显数据处理
            let initChecked = this.selectIds;
            let resultTable = this.$refs.result_table;
            resultTable.setInitChecked(initChecked, this.needDisabled);
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'regionName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.regionName != null) {
                            return '<span>' + row.regionName + '</span>';
                        } else {
                            return '<span>' + row.street + '</span>';
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            onConfigReady: function () {
            },
            // 根据不同信息变换查询信息
            popupHandler: function (fieldCode, curValue, curText) {
                let self = this;
                if(fieldCode == 'regionId') {
                    let params = {
                        provinceId: self.provinceId,
                        cityId: self.cityId,
                        countyId: self.countyId,
                    };
                    openRegionForSelectDlg(params, function (result) {
                        let query_model_ctrl = self.$refs['query_model_ctrl'];
                        let fieldInfo = {
                            regionId: {
                                value: result.regionId,
                                text: result.regionName
                            }
                        };
                        query_model_ctrl.updateFields(fieldInfo);
                        self.provinceId = result.provinceId;
                        self.cityId = result.cityId;
                        self.countyId = result.countyId;
                    });
                }
            },
            queryEventHanlder: function (itemCode, eventName, itemValue, filterItems) {
                //模拟代码：当审核状态变为“已审核”时隐藏“包含已删除的”字段，禁用销售金额字段；
                if(eventName == 'change') {
                    // 清除地区过滤
                    if(itemCode == 'regionId' && Utils.isNoB(itemValue)) {
                        this.provinceId = null;
                        this.cityId = null;
                        this.countyId = null;
                        //
                        let query_model_ctrl = this.$refs['query_model_ctrl'];
                        let data = {forcedValue: null, text: null};
                        let fieldInfo = {};
                        fieldInfo[itemCode] = data;
                        query_model_ctrl.updateFields(fieldInfo);
                    }
                }
            },
            //
            handleClick(tab, event) {
                if(this.activeName != this.activeNameCache) {
                    this.activeNameCache = tab.name;
                    this.pageNoChangeHandler(1, this.pageSize);
                }
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.toGetRetailerComList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.toGetRetailerComList();
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            toGetRetailerComList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                //
                if(self.activeName == 'virtual') {
                    filterItems.renterVirtual = true;
                } else {
                    filterItems.renterVirtual = false;
                }
                //
                if(!Utils.isNoB(filterItems.regionId)) {
                    filterItems.regionId = null;
                    //
                    filterItems.provinceId = self.provinceId;
                    filterItems.cityId = self.cityId;
                    filterItems.countyId = self.countyId;
                }
                //
                let filterList = self.filter || [];
                for(let filterCode in filterList) {
                    filterItems[filterCode] = filterList[filterCode];
                }
                //
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading();
                retailerApi.getRetailerComPagedListForRent(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let data = result.data;
                        //
                        self.totalCount = data.pagination.totalCount;
                        self.renderTable(data.rows, data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDlgResult: function () {
                let selectList = this.getTableSelection() || [];
                //
                let result = {};
                if(selectList.length <= 0) {
                    result.type = "warn";
                    if(Utils.isTrue(this.checkBox)) {
                        result.message = "请选择至少一个客户机构！";
                    } else {
                        result.message = "请选择客户机构！";
                    }
                } else {
                    result.type = "info";
                    result.data = selectList;
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/RetailerComListOfMineForSelect.vue